module.exports = __webpack_public_path__ + "static/media/GEEPAS-logo2.0c7961f7.jpeg";